import { createAction } from "@reduxjs/toolkit"
import { GenericUpdateActionPayload } from "../interfaces/action"
import { IUpdateProviderVerificationDto } from "../shared/dto/admin.dto";
import { IRegisterUserDto } from "../shared/dto/register-user.dto";

function withPayloadType<T>() {
    return (t: T) => ({ payload: t });
  }
const createActionWithPayload = <T>(action: string) => createAction(action, withPayloadType<T>());

enum NameSpaces {
  //Generic NameSpaces
  Undefined = "[Not implemented]" , //Namespace not given
  Update = "[Update]" , //Updates state
  API = "[API]" , //API's call apis
  Event = "[Event]", //Events are app events(used to fire other actions in sagas)

  //App Specific NameSpaces
  Admin = "[Admin]",
}

const generateActionName = (generateActionName: string, namespace: NameSpaces = NameSpaces.Undefined) => `${namespace} | ${generateActionName}`



//Generic Actions
export const AppInit = createAction<undefined>(generateActionName("App Started", NameSpaces.Event))
export const ApiRequest = createAction<undefined>(generateActionName("API", NameSpaces.API))
export const ApiRequestFailure = createAction<undefined>(generateActionName("API Failed", NameSpaces.API))
export const ApiRequestSuccess = createAction<undefined>(generateActionName("API Success", NameSpaces.API))
export const GenericUpdate = createAction<GenericUpdateActionPayload<any>>(generateActionName("Generic Update", NameSpaces.Update))
export const NavigateApp = createAction<string | undefined>(generateActionName("Navigate", NameSpaces.Update))

//Registration
export const LoginAdmin = createAction<any>(generateActionName("Login Admin", NameSpaces.Admin));
export const Logout = createAction<any>(generateActionName("Logout", NameSpaces.Admin));

//Providers
export const GetAllProviders = createAction(generateActionName("All Providers", NameSpaces.API))
export const UpdateProviderStatus = createAction<IUpdateProviderVerificationDto>(generateActionName("Update Provider Status", NameSpaces.API))